<ng-container *ngIf="createProfileData$ | async as createProfileData">
  <app-card-create-profile *ngIf="createProfileData.profiles.length < maxNumberOfProfiles"></app-card-create-profile>
</ng-container>
